import 'core-js/actual';
import 'regenerator-runtime/runtime';
import 'utils/Url';
import runApplication from 'utils/framework/main';

runApplication();
